import { Alert, Link } from '@amzn/awsui-components-react';
import { History } from 'history';
import { useContext } from 'react';

import { constants } from '../../../common/Localization';
import { generatePluralStr } from '../../../common/util';
import RumContext from '../../../contexts/RumContext';
import { ErrorMsgFormat, routeChange } from './CommonTcoErrorHandler';

interface Props {
    errorMessages: ErrorMsgFormat[],
    history: History,
}

const GenerateErrorMessageBox = ({errorMessages, history}: Props): JSX.Element | null => {
    const {recordEvent} = useContext(RumContext);
    if (!errorMessages || errorMessages.length === 0) {
        return null;
    }
    return (
        <Alert type='warning' header={constants.EXCLUSION_TITLE}>
            <ul>
                {errorMessages.map((errorMsg, index) => {
                    return errorMsg.path ? (
                        <li key={index}>
                            <Link
                                onFollow={() => {
                                    // record a RUM event when a link in the TCO warning alerts is clicked
                                    recordEvent({type: 'TCOWarningLink', data: {user_interaction: 'click'}});
                                    routeChange(history, errorMsg.path + '', errorMsg.targetColumn, errorMsg.targetValue, errorMsg.targetTab);
                                }}
                            >
                                {generatePluralStr(errorMsg.count, errorMsg.singular, errorMsg.plural, true)}&nbsp;
                            </Link>
                            {errorMsg.text}
                            {errorMsg.tailingComponent}
                        </li>
                    ) : (
                        <li key={index}>
                            {generatePluralStr(errorMsg.count, errorMsg.singular, errorMsg.plural, true)}&nbsp;
                            {errorMsg.text}
                            {errorMsg.tailingComponent}
                        </li>
                    );
                })}
            </ul>
        </Alert>  
    );
};

export default GenerateErrorMessageBox;
